import { cond, get, T } from 'lodash/fp';
import { DefaultTheme } from 'styled-components';
import { getSpacingToken } from '@optimus-web/core';
import {
    BODY_CELL_DEFAULT_HEIGHT,
    EXCEPTION_OPEN_INTERVAL_DIVIDER_HEIGHT,
    EXCEPTION_OPEN_INTERVAL_HEIGHT,
    OPEN_HOURS_INTERVAL_HEIGHT,
    SIZE_PER_EXCEPTION,
} from '../constants';

const calculateRowHeight = (exceptionCount: number, hourIntervalsCount: number, theme: DefaultTheme) => {
    const exceptionsHeight = exceptionCount * SIZE_PER_EXCEPTION;
    const exceptionOpenIntervalHeight = exceptionCount > 0 ? EXCEPTION_OPEN_INTERVAL_HEIGHT : 0;
    const hourIntervalsHeight = hourIntervalsCount * OPEN_HOURS_INTERVAL_HEIGHT;
    const spacingBetween =
        (exceptionCount + hourIntervalsCount + (exceptionOpenIntervalHeight !== 0 ? 1 : 0)) *
        getSpacingToken('50')({ theme });
    const dividerHeight = hourIntervalsCount > 0 && exceptionCount > 0 ? EXCEPTION_OPEN_INTERVAL_DIVIDER_HEIGHT : 0;
    const totalPaddingHeight = getSpacingToken('200')({ theme }) * 2;
    const totalHeight =
        exceptionsHeight +
        exceptionOpenIntervalHeight +
        hourIntervalsHeight +
        spacingBetween +
        dividerHeight +
        totalPaddingHeight;

    if (totalHeight < BODY_CELL_DEFAULT_HEIGHT) return BODY_CELL_DEFAULT_HEIGHT;

    return totalHeight;
};

export const getCellHeightsByRow = (exceptionCounts: number[], hourIntervalsCounts: number[], theme: DefaultTheme) =>
    exceptionCounts.map((exceptionCount, i) => calculateRowHeight(exceptionCount, hourIntervalsCounts[i], theme));

export const createBodyCellColorMapper = ({ onClosed, onOpened, onDefault }: $TSFixMe) =>
    cond([
        [get('isClosed'), onClosed],
        [get('isOpened'), onOpened],
        [T, onDefault],
    ]);
